// extracted by mini-css-extract-plugin
export var formGroup = "Form-module--formGroup--e+n5r";
export var inlay = "Form-module--inlay--lOvFc";
export var item = "Form-module--item--wFIWV";
export var reverse = "Form-module--reverse--a1Bst";
export var root = "Form-module--root--jJEhC";
export var withInlay = "Form-module--withInlay--75bqt";